import DiiaCard from './views/diia.c.js';
export default DiiaCard;
